<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;" >

          <a class="back" href="javascript:void(0)" @click="goBack" style="margin-top: 0px;margin-left: 20px;">
            <img width="130" src="../../static/images/back_myid.png" />
          </a>
          <div class="logo-row" @click="goSelectPage">
            <div class="logo-combo" aria-label="app logos">
              <img class="logo-combo-bg"  src="/static/images/select_page/select_logo_bg.png" alt="logo background">
              <div class="logo-combo-icons"><img class="logo-combo-icon" src="/static/images/select_page/select_chineasy_logo.png" alt="Chineasy logo">
                <img class="logo-combo-icon" src="/static/images/select_page/select_japaneasy_logo.png" alt="Japaneasy logo">
              </div>
            </div>
          </div>
          <div class="account ac" @click="getMenu('myAccount')">
            <img class="account-img" :src="avatar" />
          </div>
        </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
      props: ['message'],
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
              avatar: "",
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }

          this.avatar = localStorage.getItem('avatar')?localStorage.getItem('avatar'):"../../static/images/account.png";
        },
		methods: {
      goSelectPage(){
        this.$router.push({path:'/select'});
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
      goBack() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else if (/Android/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else{
          window.location.href = "mytel://back";
        }
      }
		}
    }
</script>
<style scoped>

.logo-row {
  display: flex;
  justify-content: center;

}

.logo-combo {
  position: relative;
  width: clamp(150px, 30vw, 260px);
  height: clamp(95px, 16vw, 90px);
}

.logo-combo-bg {
  width: 100%;
  height: 100%;
  display: block;
}

.logo-combo-icons {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(10px, 2.6vw, 14px);
}

.logo-combo-icon {
  width: clamp(90px, 16vw, 92px);
  height: auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexHeader.vue